import base from '@/__vue2stone/service/wasaapi/v1/__base';
import time from '@/service/base/time';
import S_checklistRecord from '@/service/api/v1/checklist_record';
import store from '@/store';
import scope from '@/service/api/v1/scope';

export default {
  async alertIndex(factoryId, params, type = 'factory') {
    const currentFactory = store.state.app.factory;
    let _params = {};
    _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params = {
        organization: currentFactory.id,
        ..._params,
      };
      delete _params.factory;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'alert',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async alertCurrentAddIndex(factoryId, params, type = 'factory') {
    const currentFactory = store.state.app.factory;
    const _params = {...params};
    if (type === 'organization') {
      _params.organization = currentFactory.id;
    } else {
      _params.factory = currentFactory.id;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'alert/current_add',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async show(alertId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      modelName: 'alert',
      modelId: alertId,
      params: _params,
    });
    return res;
  },
  setAlertData(data) {
    return {
      ...data,
      launchAt: time.getTimeFormat(data.created_at, 'YYYY-MM-DD HH:mm:ss'),
      excludeAt: data.solved_at
        ? time.getTimeFormat(data.solved_at, 'YYYY-MM-DD HH:mm:ss')
        : '',
      excludeAvatar: data.solver ? data.solver : { name: '', avatar: '' },
    };
  },
  async getChecklistQuesAns(recordId) {
    const ans = await S_checklistRecord.answerIndex(recordId);
    const _recordAnswers = S_checklistRecord.getRecordAnswers(ans); // this.recordAnswers
    return _recordAnswers;
  },
  async getChecklistQuesRecord(recordId) {
    const res = await S_checklistRecord.show(recordId);
    const recordContent = S_checklistRecord.getRecordData(res);
    const _questions = recordContent.questions; // this.recordContent.questions
    return _questions;
  },
  setEventList(data) {
    if (!data) return [];
    let _list = [];
    const _task = data.task;
    if (_task && (scope.$_isAvailable(['task-read']) || scope.$_isAvailable(['task-read-all']))) {
      _list.push({ id: _task.id, type: 'task' });
    }
    return _list;
  },
  async solveAlert(alertId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'alert',
      parentId: alertId,
      modelName: 'solve',
      data: _data,
    });
    return res;
  },
  async unsolveAlert(alertId, data) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'alert',
      parentId: alertId,
      modelName: 'unsolve',
      data: _data,
    });
    return res;
  },
  async indexPrint(params) {
    const currentFactoryId = store.state.app.factory.id;
    const res = await base.index({
      parentName: 'factory',
      parentId: currentFactoryId,
      modelName: 'alert_print/index',
      params,
    });
    return res;
  },
  async getCardAmount(params) {
    const currentFactoryId = store.state.app.factory.id;
    const {from,start_time, end_time, time_field} = params
    const resAll = await this.alertIndex(currentFactoryId,{
      from,start_time, end_time, time_field
    });
    const resAlert = await this.alertIndex(currentFactoryId, {
      ...params,
      level: 2,
      solved_at: "null",
    });
    const resEarly = await this.alertIndex(currentFactoryId, {
      ...params,
      level: 1,
      solved_at: "null",
    });
    return {resAll, resAlert, resEarly};
  },
  async tabIndex(params) {
    const currentFactoryId = store.state.app.factory.id;
    const _params = {
      factory: currentFactoryId,
      ...params
    };
    const res = await base.index({
      parentName: 'v1/factory',
      parentId: currentFactoryId,
      modelName: 'alert/tab_index',
      params: _params,
    });
    return res;
  },
};
